import { render, staticRenderFns } from "./RecurringPaymentsProductRegisterIframe.vue?vue&type=template&id=7d98f63d&"
import script from "./RecurringPaymentsProductRegisterIframe.vue?vue&type=script&lang=ts&"
export * from "./RecurringPaymentsProductRegisterIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports